import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-white px-5 py-16" data-id="element-219" data-mp="2sk41z76p1a4p">
      <div className="mx-auto max-w-2xl border border-line bg-stone-50 p-8 text-center sm:p-12" data-id="element-220" data-mp="369pi89t3zb91">
        <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[.22em] text-clay-500" data-id="element-221" data-mp="31jhfcaxxuiup">
          <Clock3Icon className="h-4 w-4" data-id="element-222" data-mp="3g72i23qwig23" />
          Limited-time launch offer
        </p>
        <h2 className="mt-4 font-display text-[2rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-4xl" data-id="element-223" data-mp="3b9typzu0o5z9">
          The launch price expires in
        </h2>
        <div className="my-9" data-id="element-224" data-mp="3l6ovad6qbwaw">
          <CountdownTimer size="large" data-id="element-225" data-mp="3l8ji5x1k9yhm" />
        </div>
        <p className="text-sm font-semibold text-ink-800" data-id="element-226" data-mp="1uuslseulhjrn">
          After that the price goes up by $5 and never comes back down.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-227" data-mp="1quijbc60hbhj">
          <div className="h-2.5 overflow-hidden bg-stone-200" data-id="element-228" data-mp="2stoabvnvf7fi">
            <div className="h-full w-[72%] bg-clay-500" data-id="element-229" data-mp="2sv95nni0euef" />
          </div>
          <div className="mt-3 flex justify-between gap-3 text-[10px] font-semibold uppercase tracking-[.16em]" data-id="element-230" data-mp="2xtsrlnwls66s">
            <span className="text-clay-500" data-id="element-231" data-mp="32r2fv089abt1">Limited availability today</span>
            <span className="text-ink-600" data-id="element-232" data-mp="37iu4v6brk9h2">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}